
export default [
  {
    path: "/dashboard",
    name: "dashboard",
    component: () => {
      const dashboardVersion = localStorage.getItem('dashboard_version') || '2';
      if (dashboardVersion === '2') {
        return import("@/modules/Dashboard/pages/DashboardV2")
      }
      return import("@/modules/Dashboard/pages/Dashboard")
    },
    meta: { title: "Dashboard" },
  },
];
